import { render, staticRenderFns } from "./SportsIndex.vue?vue&type=template&id=c5e01f16&"
import script from "./SportsIndex.vue?vue&type=script&lang=js&"
export * from "./SportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports